import api from "./api";

// 新增
export const courseCollectionPageAdd = params => {
  return api("post", `/v1/management/course-collection-page/add`, params);
};

// 删除
export const courseCollectionPageDelete = id => {
  return api("delete", `/v1/management/course-collection-page/delete/${id}`);
};

// 课程集合页详情
export const courseCollectionPageDetail = id => {
  return api("get", `/v1/management/course-collection-page/detail/${id}`);
};

// 编辑
export const courseCollectionPageEdit = params => {
  return api("post", `/v1/management/course-collection-page/edit`, params);
};

// 课程集合页列表
export const courseCollectionPageList = params => {
  return api("post", `/v1/management/course-collection-page/list`, params);
};

// 发布
export const courseCollectionPagePublish = id => {
  return api("post", `/v1/management/course-collection-page/publish/${id}`);
};